export default {"src":"/_next/static/media/sorbet.98fcb1b5.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};